import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import ModalActualizarFechaVencimiento from 'akasia-components/cliente/orden/Modales/ModalActualizarFechaVencimiento';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';
import Banderas from 'akasia-components/cliente/Banderas';
import SeccionLeads from 'akasia-components/leads/SeccionLeads';

const SeccionCliente = ({
    loadingInfoDetallesOrden,
    orden,
    bPagoAntesOrden,
    id
}) => {
    const [showEditFecha, setShowEditFecha] = useState(false);

    return (
        <Col md={6} lg={4} className="mb-4 mb-lg-0">
            {loadingInfoDetallesOrden ? <Skeleton width={300} count={5} /> : <>
                <h5 className="mb-3 fs-0">Datos del cliente</h5>
                <h5 className="mb-2"><Link to={"/clientes/detalle/" + orden.idClienteAkasia}>{orden.vNombreCliente}</Link></h5>
                <p className="mb-1 fs--1">
                    {orden.vEstadoDepProv}, {orden.vPais} <Banderas Height={20} vPais={orden.vPais}></Banderas>
                </p>
                <p className="mb-0 fs--1">
                    <strong>
                        Email: <a href={"mailto:" + orden.vEmail}><span className="text-lowercase">{orden.vEmail}</span></a>
                    </strong>
                </p>
                <p className="mb-0 fs--1">
                    <strong>
                        Tel&eacute;fono: <a href={"https://wa.me/" + orden.vTelefonoPersonal} target="_blank" rel="noreferrer"><img width="25" src="/img/whatsapp40.png"></img> {orden.vTelefonoPersonal}</a>
                    </strong>
                </p>
                {orden.vTelefonoTrabajo &&
                    <p className="mb-0 fs--1">
                        <strong>
                            Tel&eacute;fono Trabajo: <a href={"https://wa.me/" + orden.vTelefonoTrabajo} target="_blank" rel="noreferrer"><img width="25" src="/img/whatsapp40.png"></img>  {orden.vTelefonoTrabajo}</a>
                        </strong>
                    </p>
                }
                <hr></hr>
                <p className="mb-1 fs--1">Orden creada el {orden.dFechaRegistro}</p>

                {
                    orden.vClave == "99" ?
                        <>
                            <p className="mb-1 fs--1">Fecha limite de pago&nbsp;
                                {
                                    new Date(orden.dFechaVencimiento).toLocaleDateString('es-MX', {
                                        year: 'numeric', month: 'long', day: '2-digit'
                                    })
                                }
                                <span className="ms-2 text-primary" style={{ cursor: 'pointer' }} onClick={() => {
                                    setShowEditFecha(true);
                                }}>
                                    <FontAwesomeIcon icon={faEdit} />
                                </span>
                            </p>
                        </> :
                        <></>
                }

                {
                    bPagoAntesOrden == 1 &&
                    <SoftBadge
                        pill
                        bg={'danger'}
                        className="fs--2"
                    >
                        <span className="mb-0">
                            INCIDENCIA. Orden registrada 3 o m&aacute;s d&iacute;as despu&eacute;s del pago!!!
                        </span>
                    </SoftBadge>
                }
            </>}
            {showEditFecha && (
                <ModalActualizarFechaVencimiento
                    showModal={showEditFecha}
                    setShowModal={setShowEditFecha}
                    ordenSeleccionada={orden}
                    onSuccessCallback={() => setTimeout(() => window.location.reload(), 1000)}
                />
            )}
            <SeccionLeads
                idOrden={id}
            ></SeccionLeads>
        </Col>
    );
};

SeccionCliente.propTypes = {
    loadingInfoDetallesOrden: PropTypes.bool.isRequired,
    orden: PropTypes.object.isRequired,
    bPagoAntesOrden: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired
};

export default SeccionCliente;